export default "__VITE_ASSET__C9b$rGUT__"